'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const inRange = (from, to, value) => {
  if (value < from) {
    return from;
  }
  if (value > to) {
    return to;
  }
  return value;
};
const formatNumber = (amount) => {
  if (amount === null) {
    return "0.00";
  }
  let amountString = `${amount}`;
  if (amountString.includes(".")) {
    const secondDecimal = amountString.indexOf(".") + 3;
    amountString = amountString.substring(0, secondDecimal);
  }
  return amountString;
};

exports.formatNumber = formatNumber;
exports.inRange = inRange;
